import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import * as lottie from './lottie.js';

@Component({
  selector: 'mj-lottie-wrapper',
  template: '<div class="lottie-wrapper" #lottieWrapper></div>',
})
export class LottieWrapperComponent implements OnInit {
  @ViewChild('lottieWrapper', { static: true }) lottieWrapper;
  @Output() animCreated = new EventEmitter();
  @Input() source: string;
  @Input() config: Object;

  ngOnInit() {
    let config = {
      wrapper: this.lottieWrapper.nativeElement,
      path: this.source,
      renderer: 'svg',
      autoplay: false,
      loop: false,
      autoloadSegments: false,
      rendererSettings: {
        progressiveLoad: false,
        preserveAspectRatio: 'xMaxYMax slice',
      },
    };

    if (this.config) {
      config = { ...config, ...this.config };
    }

    const lottieConfig = lottie.loadAnimation(config);

    this.animCreated.emit(lottieConfig);
  }
}
